import React from 'react';
import PropTypes from 'prop-types';
import { Image, Text, View, StyleSheet } from 'react-native';
import Button from './Button';
import { colors } from '~/values';

const styles = StyleSheet.create({
  emptyContainer: {
    marginVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyImage: {
    tintColor: colors.grayDark,
    width: 50,
    height: 50,
    marginBottom: 20,
  },
  emptyText: {
    color: colors.grayDark,
    fontSize: 18,
    textAlign: 'center',
    marginHorizontal: 16,
    fontWeight: '600',
    marginBottom: 15,
  },
  emptySubText: {
    color: colors.grayDark,
    fontSize: 15,
    textAlign: 'center',
    marginHorizontal: 16,
    marginBottom: 15,
  },
});

function EmptyView({
  message, icon, actionTitle, action, actionColor, submessage,
}) {
  return (
    <View style={styles.emptyContainer}>
      <Image
        resizeMode="contain"
        style={styles.emptyImage}
        source={icon}
      />
      <Text style={styles.emptyText}>{message}</Text>
      {submessage &&
        <Text style={styles.emptySubText}>{submessage}</Text>
      }

      {actionTitle ?
        <Button
          title={actionTitle}
          onPress={() => { action(); }}
          color={actionColor || colors.accentColor}
        />
        :
        null
      }
    </View>
  );
}

EmptyView.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.number.isRequired,
  submessage: PropTypes.string,
  actionTitle: PropTypes.string,
  actionColor: PropTypes.string,
  action: PropTypes.func,
};

export default EmptyView;
